export default "__VITE_ASSET__By2gbDxh__"